export default {
  // convert role to readable text
  'users.tableRole.sysAdmin': 'System administrator',
  'users.tableRole.rootUser': 'Root user',
  'users.tableRole.orResearcher': 'Researcher',
  'users.tableRole.orStudyAdmin': 'Study administrator',
  'users.tableRole.vrnDataAdmin': 'Data administrator',
  'users.tableRole.vrnResearchPartner': 'Research partner user',
  'users.tableRole.rdmAnnotator': 'Annotator',
  'users.tableRole.rdmAnnotationSupervisor': 'Annotation supervisor',
  'users.tableRole.annotationManager': 'Annotation manager',
  'users.tableRole.annotationUser': 'Annotation user',
  'users.tableRole.accuracyViewer': 'Accuracy viewer',
};
